import React from "react";
import Sidebaar from "../Component/Sidebar";

function Dashboard() {
  return (
    <>
      <Sidebaar
        content={
          <>
            {/* <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              <div className="bg-blue-500 p-4">Column 1</div>
              <div className="bg-green-500 p-4">Column 2</div>
              <div className="bg-yellow-500 p-4">Column 3</div>
              <div className="bg-red-500 p-4">Column 4</div>
            </div> */}
            <div className="col-md-12">
              <div className="row dashbox gy-4">
                <div className="col-md-4">
                  <div
                    className=" p-4 align-items-center rounded-3 d-flex align-items-center gap-4"
                    style={{ background: "#ffe2e6" }}
                  >
                    <div className="icontag bg-redish">
                      <i className="fa-solid fa-users"></i>
                    </div>
                    <div className="text-start">
                      <h5>12</h5>
                      <h6>Total Customer</h6>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div
                    className=" p-4 align-items-center rounded-3 d-flex align-items-center gap-4"
                    style={{ background: "#fff4de" }}
                  >
                    <div className="icontag bg-orange">
                    <i class="fa-solid fa-file"></i>
                    </div>
                    <div className="text-start">
                      <h5>5</h5>
                      <h6>Total Membership</h6>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div
                    className=" p-4 align-items-center rounded-3 d-flex align-items-center gap-4"
                    style={{ background: "#dcfce7" }}
                  >
                    <div className="icontag bg-greenish">
                    <i class="fa-solid fa-indian-rupee-sign"></i>
                    </div>
                    <div className="text-start">
                      <h5>4</h5>
                      <h6>Today Membership Sell</h6>
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div
                    className=" p-4 align-items-center rounded-3 d-flex align-items-center gap-4"
                    style={{ background: "#83C0C1" }}
                  >
                    <div className="icontag bg-white">
                    <i class="fa-solid fa-tag text-dark"></i>
                    </div>
                    <div className="text-start">
                      <h5>7</h5>
                      <h6>Total Brand</h6>
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
          </>
        }
      />
    </>
  );
}

export default Dashboard;
